import type { ApgarComponentKey, ApgarComponents } from '@type/antenatal.type'

export const APGAR_COMPONENTS: { key: ApgarComponentKey; label: string; hint: string }[] = [
  { key: 'activity', label: 'Activity', hint: 'Muscle tone' },
  { key: 'pulse', label: 'Pulse', hint: 'Heart rate' },
  { key: 'grimace', label: 'Grimace', hint: 'Reflex' },
  { key: 'appearance', label: 'Appearance', hint: 'Colour' },
  { key: 'respiration', label: 'Respiration', hint: 'Breathing' }
]

const KEYS = APGAR_COMPONENTS.map(c => c.key)

export function apgarTotal(components: Partial<ApgarComponents> | null | undefined): number | undefined {
  if (!components) return undefined
  if (KEYS.some(key => components[key] == null || !Number.isFinite(Number(components[key])))) return undefined
  return KEYS.reduce((sum, key) => sum + Number(components[key]), 0)
}

/** All five scores present, each 0–2. */
export function completeApgar(components: Partial<ApgarComponents> | null | undefined): ApgarComponents | undefined {
  const total = apgarTotal(components)
  if (total == null || !components) return undefined
  const scored = {} as ApgarComponents
  for (const key of KEYS) {
    const score = Number(components[key])
    if (score < 0 || score > 2) return undefined
    scored[key] = score
  }
  return scored
}

export function apgarStarted(components: Partial<ApgarComponents> | null | undefined) {
  if (!components) return false
  return KEYS.some(key => components[key] != null && components[key] !== ('' as unknown))
}

export function formatApgar(total: number | null | undefined, components?: ApgarComponents | null) {
  const score = total == null ? '—' : String(total)
  if (!components) return score
  const parts = APGAR_COMPONENTS.map(c => `${c.label} ${components[c.key]}`).join(', ')
  return `${score} (${parts})`
}

export function mapApgarComponents(raw: unknown): ApgarComponents | null {
  if (!raw || typeof raw !== 'object') return null
  const source = raw as Record<string, unknown>
  const scored = {} as ApgarComponents
  for (const key of KEYS) {
    const score = Number(source[key])
    if (!Number.isFinite(score)) return null
    scored[key] = score
  }
  return scored
}
